import { createFileRoute } from '@tanstack/react-router'
import { AccessPage } from '~/components/routes/administration/access/access-page'
import { ACCESS_TAB_VIEW } from '~/components/routes/administration/access/permissions'
import { withRoutePermissions } from '~/utils/rbac'
import { accessSearchSchema } from './-access-search-schema'

/**
 * `/administration/access` — écran « Utilisateurs & accès » (spec du 19/09).
 *
 * Il vit sous **Administration**, et non sous « Utilisateurs » : les comptes du back-office et les
 * rôles (`users.bo-users.*`, `roles-admin.*`) ne s'ouvrent pas aux mêmes personnes que les
 * utilisateurs de l'app (`users.app-users.*`). Mélanger les deux dans une même barre d'onglets
 * aurait fait d'un droit sur les clients de l'app un chemin vers l'administration des accès.
 *
 * La garde est un OU : la page s'ouvre dès que l'un des deux axes est accessible, et l'axe interdit
 * est désactivé **dans** la page avec le tooltip des droits manquants (§9).
 *
 * Les search params `roleForm`/`roleId` pilotent la modale de création/édition de rôle : les anciennes
 * routes `/administration/roles/new` et `/administration/roles/$roleId/edit` y redirigent pour ne
 * casser aucun lien entrant.
 */
export const Route = createFileRoute('/_authenticated/administration/access')({
  validateSearch: accessSearchSchema,
  staticData: { permission: ACCESS_TAB_VIEW },
  component: AccessPage,
})
withRoutePermissions(Route)
